import { render } from "./QuestionnaireV2.vue?vue&type=template&id=13c66f15&scoped=true"
import script from "./QuestionnaireV2.vue?vue&type=script&lang=js"
export * from "./QuestionnaireV2.vue?vue&type=script&lang=js"

import "./QuestionnaireV2.vue?vue&type=style&index=0&id=13c66f15&scoped=true&lang=less"

import exportComponent from "E:\\Code\\TECS\\TECS-FE-ENDUSER-NEW\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c66f15"]])

export default __exports__